import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QualityOdsService {

  ODSApiUrl: string = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  getReportTypes(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/GetReportsForQA', data);
  }
  getBaseDetails(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'MES/GetBaseDetail', data);
  }
  getThickness(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/GetThickness', data);
  }

  getLastCommonAttribute(data: any): Observable<any> {
    return this.http.post<any>(
      this.ODSApiUrl + 'QA/GetLastEnteredCommonAttributes',
      data
    );
  }
  insertCommonAttribute(data: any): Observable<any> {
    return this.http.post<any>(
      this.ODSApiUrl + 'QA/InsertCommonAttributes',
      data
    );
  }
  getCommonAttributes(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/GetCommonAttributes', data);
  }
  deleteCommonAttribute(data: any): Observable<any> {
    return this.http.post<any>(
      this.ODSApiUrl + 'QA/DeleteCommonAttributes',
      data
    );
  }
  getQAProperties(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/GetQAProperties', data);
  }

  getQAEntries(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/GetQAEntries', data);
  }
  insertQAData(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/InsertQAData', data);
  }
  updateQAData(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/UpdateQAData', data);
  }
  deleteQAData(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/DeleteQAEntries', data);
  }
  getQAReport(data: any): Observable<any> {
    return this.http.post<any>(this.ODSApiUrl + 'QA/GetReport', data);
  }
}
